import { useEffect, useState } from 'react';

import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';

import useContext from "../../context";
import { getApplicationActionUrl } from "../../config";
import ApplicantFields from "./components/ApplicantFields";
import QuoteDetails from './components/QuoteDetails';
import CreditCheckAuthorization from './components/CreditCheckAuthorization';
import WorkingWithBroker from './components/WorkingWithBroker';
import ExistingLoan from './components/ExistingLoan';
import Comments from './components/Comments';
import Referrer from './components/Referrer';
import HiddenFields from './components/HiddenFields';

const lang = {
  noCreditCheck: {
    title: 'No Credit Check Option',
  },
  creditCheck: {
    title: 'Credit Check Option',
  }
}

export default function LoanApplication() {
  const [context] = useContext();
  const applicationActionUrl = getApplicationActionUrl();

  const [hasCoApplicant, setHasCoApplicant] = useState(false);

  const [applicantFirstName, setApplicantFirstName] = useState(null);
  const [applicantLastName, setApplicantLastName] = useState(null);
  const [coApplicantFirstName, setCoApplicantFirstName] = useState(null);
  const [coApplicantLastName, setCoApplicantLastName] = useState(null);

  // True from the moment the browser starts posting the form until it leaves the page
  const [submitting, setSubmitting] = useState(false);

  const isRefinance = context.contractType === 'refinance';

  // Back/forward cache restores the page with its old state, so re-enable the
  // button when the visitor comes back from the thank-you page.
  useEffect(() => {
    const reset = (event) => {
      if (event.persisted) {
        setSubmitting(false);
      }
    };

    window.addEventListener('pageshow', reset);

    return () => window.removeEventListener('pageshow', reset);
  }, []);

  function normalizeApplicantFields(e) {
    const { elements } = e.target;

    ['applicant-postalcode', 'coapplicant-postalcode'].forEach((name) => {
      const field = elements.namedItem(name);
      if (field) {
        field.value = field.value.slice(0, 5);
      }
    });

    ['applicant-phone', 'coapplicant-phone'].forEach((name) => {
      const field = elements.namedItem(name);
      if (!field) return;

      let digits = field.value.replace(/\D/g, '');
      if (digits.length > 10) {
        digits = digits.slice(-10);
      }

      field.value = digits;
    });
  }

  function handleSubmit(e) {
    // The server takes a few seconds to create the lead and send the emails;
    // a second post in that time would create a duplicate.
    if (submitting) {
      e.preventDefault();
      return;
    }

    normalizeApplicantFields(e);
    setSubmitting(true);
  }

  return (
    <React.Fragment>
      <QuoteDetails />
      <div className="quoteform__content">
        <form
          action={applicationActionUrl || undefined}
          className="quoteform__form"
          method="post"
          onSubmit={handleSubmit}
          aria-busy={submitting}
        >
          <h2 className="quoteform__page-title">Apply for a Loan - {lang[context.selectedOption]}</h2>
          <fieldset>
            <legend className="quoteform__heading">Primary Applicant</legend>
            <ApplicantFields prefix="applicant-" setFirstName={setApplicantFirstName} setLastName={setApplicantLastName} />
          </fieldset>
          <fieldset>
            <legend className="quoteform__heading">Co-Applicant</legend>
            <div className="quoteform__text">Will there be a co-applicant on the loan application?</div>
            <div className="quoteform__input quoteform__input--noMarginBottom quoteform__input--halfMarginTop">
              <FormControlLabel
                control={
                  <Switch
                    name="coapplicant"
                    color="primary"
                    onChange={e => setHasCoApplicant(e.target.checked)}
                  />
                }
                label={(hasCoApplicant ? "No " : "") + "Co-Applicant"}
              />
            </div>
            {
              hasCoApplicant && (
                <ApplicantFields prefix="coapplicant-" setFirstName={setCoApplicantFirstName} setLastName={setCoApplicantLastName} />
              )
            }
          </fieldset>
          {
            context.loanOption === 'creditCheck' && (
              <CreditCheckAuthorization
                applicantName={applicantFirstName ? `${applicantFirstName || ''} ${applicantLastName || ''}` : ''}
                coApplicantName={hasCoApplicant && (coApplicantFirstName ? `${coApplicantFirstName || ''} ${coApplicantLastName || ''}` : '')}
              />
            )
          }
          {
            !isRefinance && <WorkingWithBroker />
          }
          {
            isRefinance && <ExistingLoan />
          }
          <Comments />
          <Referrer />
          <HiddenFields />
          <div className="quoteform__actions">
            <button type="submit" disabled={submitting}>
              {submitting && <span className="quoteform__spinner" aria-hidden="true" />}
              <span>{submitting ? 'Submitting…' : 'Submit'}</span>
            </button>
          </div>
        </form>
      </div>
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// blocks/quote-calculator/app/components/LoanApplication/index.js